import React from 'react';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import CustomModal from 'shared/CustomModal';
import { IOption } from 'shared/FormikField/FormikField.model';
import { ISowDataListItem } from '@EngagementsSowData/sowData.model';
import FormikTextareaField from 'shared/FormikField/FormikTextareaField';
import { IActiveNumbersItem } from '@EngagementsActiveNumbers/activeNumbers.model';
import { IRenewalSowDataItem } from '@EngagementsRenewalSowData/renewalSowData.models';
import FormikSelectField from 'shared/FormikField/FormikSelectField/FormikSelectField';
import EscalationSupportInfo from 'pages/WirelineEngagements/shared/EscalationSupportModalForm/EscalationSupportInfo/index';
import { IContract } from 'pages/ContractManagment/ContractManagement.models';

import './EscalationSupporModal.scss';

interface IEscalationSupportModalProps {
  escalationTypeOptions: IOption[]
  isLoading: boolean
  cleanEscalationSupportRow: () => void;
  isVisibleLocation?: boolean | undefined
  escalationSupportRowId: string | number | undefined | null;
  escalationSupportRow: ISowDataListItem | IRenewalSowDataItem | IActiveNumbersItem | IContract;
}

const EscalationSupportModal: React.FC<IEscalationSupportModalProps> = ({
  isLoading,
  isVisibleLocation,
  escalationSupportRow,
  escalationTypeOptions,
  escalationSupportRowId,
  cleanEscalationSupportRow,
}) => {
  const { dirty, isSubmitting, submitForm } = useFormikContext();

  const withLeaveConfirmation = dirty && !isSubmitting;

  const closeEscalationSupportModal = () => {
    cleanEscalationSupportRow();
  };

  return (
    <CustomModal
      areButtonsVisible
      maxWidth="504px"
      isLoading={isLoading}
      confirmButtonText="Send"
      title="Escalation support"
      onClickConfirm={submitForm}
      isCancelButtonVisible={false}
      isModalOpen={!!escalationSupportRowId}
      isConfirmDialog={withLeaveConfirmation}
      onCloseModal={closeEscalationSupportModal}
    >
      <Grid
        className="escalation-support__modal"
        container
        item
        rowSpacing={3}
      >
        <FormikSelectField
          required
          fullWidth
          fieldName="type"
          label="Escalation Type"
          options={escalationTypeOptions}
        />
        <EscalationSupportInfo
          isVisibleLocation={isVisibleLocation}
          escalationSupportRow={escalationSupportRow}
        />
        <FormikTextareaField
          fieldName="details"
        />
      </Grid>
    </CustomModal>
  );
};

EscalationSupportModal.defaultProps = {
  isVisibleLocation: true,
};

export default EscalationSupportModal;
